import { Box } from '@mui/material';
import EmailEditorProvider from '../Editor/EmailEditorProvider';
import SidePanel from '../SidePanel/SidePanel';
import AttributesPanel from '../SidePanel/AttributesPanel';
import Toolbar from '../Toolbar/Toolbar';
import Canvas from '../Editor/Canvas';
import Header from './Header';
import MergeTags from '@Editor/MergeTags';

function EditorLayout() {
    return (
        <EmailEditorProvider>
            <Box
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Header />
                {/* content */}
                <Box
                    sx={{
                        display: 'flex',
                        flex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                    }}
                >
                    {/* sidepanel */}
                    <Box
                        sx={{
                            width: theme => theme.spacing(40),
                            // overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            borderRight: 1,
                            borderColor: 'divider',
                            boxShadow: theme =>
                                `0px 0px 5px 0px ${theme.palette.divider}`,
                        }}
                    >
                        <SidePanel />
                        <AttributesPanel />
                    </Box>
                    {/* main panel */}
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Toolbar />
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: 'auto',
                                position: 'relative',
                                top: 0,
                                left: 0,
                            }}
                        >
                            <Canvas />
                            <MergeTags />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </EmailEditorProvider>
    );
}

export default EditorLayout;
